import { useDispatch } from "react-redux";
import { useRouter } from "next/router";
import { generateFilterObject } from "@components/Features/catalog/catalog-utils";
import useIsMobile from "@src/hooks/useIsMobile";
import { clearFilters } from "@app/store/filtersSlice";
import { generateCatalogUri } from "@entities/catalog";
import { RouterConfig } from "@shared/lib/routerConfig";
import { UseCatalogActionsProps } from "./types";

export const useCatalogActions = ({
    setSkip,
    setFilters,
    brandValue,
    modelValue,
    generationValue,
    yearFromValue,
    bodyValue,
    transmissionValue,
    engineTypeValue,
    driveValue,
    priceFromValue,
    priceToValue,
    citiesValue,
    sourceId,
    country,
    mapMode
}: UseCatalogActionsProps) => {
    const dispatch = useDispatch();
    const router = useRouter();
    const isMobile = useIsMobile();

    const handleScrollToCatalog = () => {
        if (isMobile) {
            setTimeout(() => {
                document.getElementById("catalog-list")?.scrollIntoView({
                    behavior: "smooth",
                    block: "start"
                });
            }, 300);
        }
    };

    const reset = () => {
        dispatch(clearFilters());
        setSkip(false);
        router.push(RouterConfig.CATALOG);
    };

    const applyFilters = async (skipPush = false, forceFilters: Record<string, string> = {}) => {
        setSkip(true);
        setSkip(false);
        const newFilters = generateFilterObject({
            brandValue: brandValue?.id,
            modelValue: modelValue?.id,
            generationValue: generationValue?.id,
            yearFromValue,
            bodyValue,
            transmissionValue,
            engineTypeValue,
            driveValue,
            priceFromValue,
            priceToValue,
            citiesValue,
            sourceId,
            country,
            ...forceFilters
        });

        setFilters(newFilters);

        const catalogUri = generateCatalogUri(
            country,
            citiesValue,
            brandValue?.alias,
            modelValue?.alias,
            generationValue?.generation,
            generationValue?.restyleNumber,
            {
                bodyType: bodyValue,
                priceFrom: priceFromValue,
                priceTo: priceToValue
            }
        );

        const urlWithMapView = mapMode ? `${catalogUri}?mapView=true` : catalogUri;
        if (!skipPush) {
            await router.push(urlWithMapView, undefined, { shallow: true });
        }
    };

    return {
        handleScrollToCatalog,
        reset,
        applyFilters
    };
};